module.exports = __webpack_public_path__ + "static/media/icon_test_flight.d9d70be4.svg";